import ChildField from './child-field.js';

const pluginName = 'childField';
const elements   = '[data-child-field]';

export default {
    init() {
        $.fn[pluginName] = function() {
            return this.each((i, el) => {
                let childField = new ChildField(el);
                childField.init();
            });
        };

        $(elements)[pluginName]();

        $(document).on('enhance:ajaxload', () => {
            $(elements)[pluginName]();
        });
    }
};